<template>
  <div 
    class="px-5 py-7">
    <v-dialog v-model="dialog.pembayaran"
      @keydown.esc="dialog.pembayaran = false"
      :fullscreen="dialog.fullscreen"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Pembayaran

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.pembayaran = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <!-- <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          <ValidationObserver 
            ref="form">
            <v-form>

              <ValidationProvider
                name="Metode Pembayaran" 
                rules="required" 
                v-slot="{ errors }">
                <div 
                  class="fs-15 label-input">
                  Metode Pembayaran
                </div>

                <v-autocomplete
                  v-on:keydown.enter.prevent="save()"
                              
                  filled
                  rounded
                  dense
                  solo

                  color="#718EBF"
                  placeholder="Metode Pembayaran"
                  v-model="form.payment_method"
                  :items="['Tunai','Transfer']"
                  
                  outlined
                  class="mt-4"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                </v-autocomplete>
              </ValidationProvider>

              <!-- <v-autocomplete
                v-model="form.payment_method"
                :items="['Tunai','Transfer']"
                
                label="Pilih Tipe Pembayaran"
                
                dense
                outlined
                hide-details
                style="width: 100%"
                class="mt-4"
                >
              </v-autocomplete> -->

              <div v-if="form.payment_method === 'Transfer'">
                <ValidationProvider
                  name="Pilih Bank" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input">
                    Pilih Bank
                  </div>

                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                                
                    filled
                    rounded
                    dense
                    solo

                    color="#718EBF"
                    item-text="name"
                    item-value="name"
                    placeholder="Pilih Bank"
                    v-model="form.bank"
                    :items="bank"
                    
                    outlined
                    return-object
                    class="mt-4"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                    <template v-slot:selection="{ item }">
                      <div
                        v-if="item" style="color: #718EBF">
                        {{ item.name }} ({{ item.rek_number }})
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.rek_number }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>

              <div class="mt-3">
                <div 
                  class="fs-15 label-input">
                  <!-- <span class="red--text">*</span> -->
                  Bukti Pembayaran
                </div>
                <uploadfolder
                  v-model="upload.payment_bukti_url" 
                  style="height: 250px; width: 250px">
                  <div 
                    slot="activator"
                    class="cursor-pointer">
                    <v-card 
                      flat
                      height="250"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <div v-if="form.payment_bukti_url.length < 1">
                        <v-icon v-if="!process.payment_bukti_url"
                          size="60" 
                          color="#718EBF">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </div>

                      <v-img v-else
                        contain
                        height="250"
                        :src="form.payment_bukti_url" 
                        :alt="form.payment_bukti_url"
                        class="text-center d-flex align-center">
                        <div 
                          class="d-flex aling-center justify-center" 
                          style="width: 100%; height: auto;">
                          <v-icon v-if="!process.payment_bukti_url"
                            size="60" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>

                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </div>
                      </v-img>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>
            </v-form>
          </ValidationObserver>


          <div v-if="message.error.length > 0"
            class="text-left mt-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Ya, {{ message.status }}
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
            :disabled="process.status"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="d-flex align-center mb-2">
            <div class="color-dark-blue fs-22 font-weight-bold">
              Detail Invoice
            </div>
            <div class="ml-auto">
              <v-btn
                @click="exports()"
                :loading="process.export"
                elevation="0"
                dark
                min-height="28"
                small
                min-width="28"
                color="#bd1112"
                class="text-capitalize mx-1"
                style="border-radius: 6px;">
                <v-icon size="18" color="white">mdi-file-pdf-box</v-icon>
                <span class="ml-2">Export Pdf</span>
              </v-btn>
            </div>
          </div>

          <v-row
              class="">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 6px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
  
                  <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                    <div class="fs-18 input-label">
                      Informasi
                    </div>
                    <v-divider class="mt-4 mb-1"></v-divider>
                    <v-row>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Invoice
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.number }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Nama Customer
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.customer_name }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. BPB
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.bpb_number }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Order
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.orders_number }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Status
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.status == 'belum lunas' ? 'Belum Lunas' : detail.status == 'lunas' ? 'Lunas' : detail.status == 'Set Order' ? 'Menunggu Pengiriman' : '-' }}
                          </div>
                        </div>
                      </v-col>


                      <v-col cols="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Titip Tagihan
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            <div v-if="detail.is_titip === '1'">
                              <v-chip
                                color="green"
                                class="white--text px-4">
                                Ya
                              </v-chip>
                            </div>
                            <div v-else>
                              <v-chip
                                color="red"
                                class="white--text px-4">
                                Tidak
                              </v-chip>
                            </div>
                          </div>
                        </div>
                      </v-col>  
                      <!-- <v-col cols="12">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Catatan
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.note === '' ? '-' : detail.note }}
                          </div>
                        </div>
                      </v-col> -->
                    </v-row>
                  </v-card-text>
                </v-card>
  
                <div class="mt-5" v-if="Object.keys(order_list).length > 0">
                  <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7;" class="pb-7">
                    <v-card-text>
                      <div class="fs-18 input-label">
                        Detail Produk
                      </div>

                      <v-divider class="mt-4 mb-1"></v-divider>

                      <v-row>
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            Alamat Kirim :
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0">
                          <div>
                            <div class="fs-15 font-weight-bold">
                              {{ detail.store_name }}
                            </div>
                            <div class="text-lowercase">
                              {{ detail.customer_address }}, kel. {{ detail.customer_village_name }}, kec. {{ detail.customer_subdistrict_name }}
                              Kab. {{ detail.customer_city_name }} - {{ detail.customer_province_name }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                          <div>
                            <table style="width: 100%;">
                              <tr>
                                <td class="font-weight-bold">
                                  Nomer Order
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail.orders_number }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Nomer Surat Jalan
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail.delivery_number }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Tanggal Order
                                </td>
                                <td style="width: 80px" class="text-center">
                                  :
                                </td>
                                <td class="text-right">
                                  {{ detail.input_datetime | datetime }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Tanggal Jatuh Tempo
                                </td>
                                <td style="width: 80px" class="text-center">
                                  :
                                </td>
                                <td class="text-right">
                                  {{ detail.due_date | date }}
                                </td>
                              </tr>
                              <!-- <tr>
                                <td class="font-weight-bold">
                                  Nama Customer
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail.customer_name }}
                                </td>
                              </tr> -->
                              <!-- <tr>
                                <td class="font-weight-bold">
                                  Order By
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail.input_user_name }}
                                </td>
                              </tr> -->
                            </table>
                          </div>
                        </v-col>
                        <v-col cols="12" class="my-8">
                        <div style="overflow: auto; ">
                          <table style="width: 100%;">
                            <tr>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Kode Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Nama Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Quantity
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Per Unit
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Bruto
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Diskon Promo
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Diskon Strata
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Net. 
                              </td>
                            </tr>
                            <tr v-for="(item, index) in order_list.detail" :key="index">
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ item.detail_varian_sku }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ item.detail_varian_name }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                <!-- {{ `${item.bpb_detail_qty_dus_diterima*1}.${item.bpb_detail_qty_lusin_diterima*1}.${item.bpb_detail_qty_pcs_diterima*1}` }} -->

                                {{ `${(item.detail_total_in_dus*1) === 1 ? 0 : (item.bpb_detail_qty_dus_diterima*1)}.${item.bpb_detail_qty_lusin_diterima*1}.${(item.detail_total_in_dus*1) === 1 ? (item.bpb_detail_qty_dus_diterima*1) : (item.bpb_detail_qty_pcs_diterima*1)}` }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                <!-- Rp {{ item.detail_price_per_pcs | number_dec }}  -->
                                <span v-if="item.detail_qty_pcs !== 0">
                                  Rp. {{ item.detail_price_per_pcs | number_dec }}
                                </span>
                                <span v-else-if="item.detail_qty_lusin !== 0">
                                  Rp. {{ (item.detail_price_per_pcs*12) | number_dec }}
                                </span>
                                <span v-else-if="item.detail_qty_dus !== 0">
                                  Rp. {{ Math.round((item.detail_price_per_pcs*1)*(item.detail_total_in_dus*1)) | number_dec }}
                                </span>
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                <!-- <span v-if="item.detail_qty_pcs !== 0">{{ item.detail_price_pcs | price }}</span>
                                <span v-else-if="item.detail_qty_lusin !== 0">{{ item.detail_price_lusin | price }}</span>
                                <span v-else-if="item.bpb_detail_qty_dus_diterima !== 0">{{ item.detail_price_dus | price }}</span> -->
                                {{ ((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                {{ (((item.detail_discount*1))) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                {{ (((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                {{ ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)) - ((((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))))) | price }}
                              </td>
                            </tr>
                          </table>
                        </div>
                        <!-- <div style="overflow: auto; ">
                          <table style="width: 100%;">
                            <tr>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Kode Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Nama Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Quantity
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Per Unit
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Bruto
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Disc. 
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Net. 
                              </td>
                            </tr>
                            <tr v-for="(item, index) in order_list" :key="index">
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ item.varian_sku }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ item.varian_name }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ `${item.qty_dus_diterima}.${item.qty_lusin_diterima}.${item.qty_pcs_diterima}` }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                {{ item.varian_pricelist_pcs_ppn | price }} 
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                {{ (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                {{ item.varian_discount*1 | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                {{ (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                              </td>
                            </tr>
                          </table>
                        </div> -->
                      </v-col>
                      <v-col cols="12" md="6">
                        <!-- <div>
                          Total Qty: <span>{{ `${detail.total_qty_dus}.${detail.total_qty_lusin}.${detail.total_qty_pcs}` }}</span>, Total Item: {{ detail.detail.length }}
                        </div> -->
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                        <div class="fs-15">
                          <table style="width: 100%;">
                            <tr>
                              <td class="pa-2 font-weight-bold">
                                Harga Bruto
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                : 
                              </td>
                              <td class="pa-2 text-right">
                                {{ order_list.detail.reduce((acc, item) => acc + ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1))), 0) | price }}
                              </td>
                            </tr>
                            <tr>
                              <td class="pa-2 font-weight-bold">
                                Diskon 
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                :
                              </td>
                              <td class="pa-2 text-right">
                                <!-- {{ order_list.total_discount*1 | price }} -->
                                  {{ order_list.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))), 0) | price }}
                              </td>
                            </tr>
                            <!-- <tr>
                              <td class="pa-2 font-weight-bold">
                                PPN 11%
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                : 
                              </td>
                              <td class="pa-2 text-right">
                                {{ detail.sales_name }}
                              </td>
                            </tr> -->
                            <tr>
                              <td class="pa-2 font-weight-bold">
                                Harga Net
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                :
                              </td>
                              <td class="pa-2 text-right">
                                {{ ((order_list.detail.reduce((acc, item) => acc + ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1))), 0)) - (order_list.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))), 0))) | price }}
                              </td>
                            </tr>

                          </table>
                        </div>
                      </v-col>
                        <!-- <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Nomer Order
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.number }}
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Nama Sales
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.sales_name }}
                            </div>
                          </div>
                        </v-col>

                        <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Nama Customer
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.customer_name }}
                            </div>
                          </div>
                        </v-col>

                        <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Tanggal Order
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.input_datetime | date }}
                            </div>
                          </div>
                        </v-col> -->
                      </v-row>
                      <!-- <v-divider class="my-4"></v-divider> -->
  
                      <!-- <div v-for="(item, index) in order_list" :key="index">
                        <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                          <v-card-text>
                            <div class="fs-16 font-weight-bold label-input">
                              {{ item.varian_name }}
                            </div>
                            <div>
                              <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                            </div>
  
                            <v-divider class="my-4"></v-divider>
  
                            <v-row>
                              <v-col class="py-0 font-weight-medium">
                                Qty
                              </v-col>
                              <v-col class="py-0 font-weight-medium">
                                Qty Per Pcs
                              </v-col>
                              <v-col class="py-0 font-weight-medium">
                                Harga Per Pcs
                              </v-col>
                              <v-col class="text-right py-0 font-weight-medium">
                                Sub Total
                              </v-col>
                            </v-row>
  
                            <v-row class="pt-3" v-if="item.qty_pcs_diterima*1 !== 0">
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.qty_pcs_diterima }} Pcs
                                </div>
                              </v-col>
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  -
                                </div>
                              </v-col>
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.varian_pricelist_pcs_ppn | price }} 
                                </div>
                              </v-col>
                              <v-col class="text-right py-0">
        
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.detail_price_pcs | price }}
                                </div>
                              </v-col>
                            </v-row>
  
                            <v-row v-if="item.qty_lusin_diterima*1 !== 0">
  
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.qty_lusin_diterima }} Lusin
                                </div>
                              </v-col>
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  12
                                </div>
                              </v-col>
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.varian_pricelist_pcs_ppn | price }} 
                                </div>
                              </v-col>
                              <v-col class="text-right py-0">
        
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.detail_price_lusin | price }}
                                </div>
                              </v-col>
                            </v-row>
  
                            <v-row v-if="item.qty_dus_diterima*1 !== 0">
                              <v-col class="py-0">
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.qty_dus_diterima }} Dus
                                </div>
                              </v-col>
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.varian_total_in_dus*1 }}
                                </div>
                              </v-col>
                              <v-col class="py-0">
          
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.varian_pricelist_pcs_ppn | price }} 
                                </div>
                              </v-col>
                              <v-col class="text-right py-0">
        
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.detail_price_dus | price }}
                                </div>
                              </v-col>
                            </v-row>
  
                            <v-divider class="my-4"></v-divider>
  
                            <v-row>
                              <v-col class="label-input font-weight-bold ">
                                <div>
                                  Total
                                </div>
                              </v-col>
                              <v-col cols="12" md="4">
                                <div>
                                  
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" class="text-right">
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1 | price }}
                                </div>
                              </v-col>
                            </v-row>
  
                          </v-card-text>
                        </v-card>
                      </div> -->
  
  
                      <!-- <div>
                        <v-card flat style="background: #718ebf17; border-radius: 15px;">
                          <v-card-text>
                            <v-row>
                              <v-col cols="12" md="4">
                                <div class="label-input font-weight-bold ">
                                  Sub Total
                                </div>
                              </v-col>
                              <v-col cols="12" md="4">
                                <div>
                                  
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" class="text-right">
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ total_nominal*1 | price }}
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" md="4">
                                <div class="label-input font-weight-bold ">
                                  Biaya Kirim
                                </div>
                              </v-col>
                              <v-col cols="12" md="4">
                                <div>
                                  
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" class="text-right">
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ detail.biaya_kirim*1 | price }}
                                </div>
                              </v-col>
                            </v-row>
                            <v-divider class="my-4"></v-divider>
                            <v-row>
                              <v-col cols="12" md="4">
                                <div class="label-input font-weight-bold ">
                                  Grand Total
                                </div>
                              </v-col>
                              <v-col cols="12" md="4">
                                <div>
                                  
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" class="text-right">
                                <div class="fs-17 font-weight-bold label-input">
                                  {{ total_nominal*1 | price }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </div> -->
                    </v-card-text>
                  </v-card>
                </div>
  
                <v-card 
                  flat
                  class="mt-5"
                  style="border-radius: 6px; border: 1px solid #E7E7E7;"
                  v-if="Object.keys(detail).length > 0 &&( detail.status == 'lunas' || detail.status == 'pengajuan' )">
  
                  <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                    <div class="fs-18 input-label">
                      Detail Pembayaran
                    </div>
                    <v-divider class="mt-4 mb-1"></v-divider>
                    <v-row>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Metode Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_method }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Nama Bank
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_bank_name == '' ? '-' : detail.payment_bank_name}}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Rekening
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_rek_number == '' ? '-' : detail.payment_rek_number}}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Tanggal Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.paid_date | date }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Pembayaran Diterima Oleh
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_user_name }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Generate Otomatis
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            <div v-if="detail.is_generate === '1'">
                              <v-chip
                                color="green"
                                class="white--text px-4">
                                Ya
                              </v-chip>
                            </div>
                            <div v-else>
                              <v-chip
                                color="red"
                                class="white--text px-4">
                                Tidak
                              </v-chip>
                            </div>
                          </div>
                        </div>
                      </v-col>  
                      <v-col cols="12">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Bukti Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            <v-img
                              :src="detail.payment_bukti_url"
                              style="width: 300px; height: 300px;"
                              contain
                              v-if="detail.payment_bukti_url !== ''"
                              class="d-flex align-center justify-center mt-2"
                              alt="Bukti Pembayaran">
                            </v-img>
                            <div v-if="detail.payment_bukti_url === ''">
                              -
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <!-- <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Status
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.status == 'belum lunas' ? 'Belum Lunas' : detail.status == 'lunas' ? 'Lunas' : detail.status == 'Set Order' ? 'Menunggu Pengiriman' : '-' }}
                          </div>
                        </div>
                      </v-col> -->
                      <!-- <v-col cols="12">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Catatan
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.note === '' ? '-' : detail.note }}
                          </div>
                        </div>
                      </v-col> -->
                    </v-row>
                  </v-card-text>
                </v-card>
  
              </v-col>
            </v-row>

          

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <!-- <v-btn 
                @click="dialog.pembayaran = true; message.error = ''"
                :loading="process.load"
                :disabled="process.load"
                v-if="detail.paid_date == ''"
                width="150"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Pembayaran
              </v-btn> -->
              
              <v-btn
                to="/finance/invoice"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  import axios from "axios";
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false,
          pembayaran: false,
        },

        order_list: {},
        status: '',

        detail: {},

        rejected_reason: '',
        bank: [],
        total_diskon: 0,

        form: {
          id: '',
          bpb_arr: [],
          payment_method: 'Tunai',
          payment_bank_name: '',
          payment_rek_number: '',
          payment_bukti_url: '',
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          payment_bukti_url: null,
          image_url: null
        },
        total_nominal: 0,

        process: {
          form: false,

          load: false,
          export: false,

          image_url: false,
          payment_bukti_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.payment_bukti_url': {
        handler: function () {
          if (this.upload.payment_bukti_url) {
            this.message.error = ''
            this.process.payment_bukti_url = this.upload.payment_bukti_url.process

            if (!this.process.payment_bukti_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.payment_bukti_url = this.upload.payment_bukti_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
      this.fetchBank()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/customer_invoice/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.bpb_arr = []
            this.detail = res.results.data
            this.fetchDetailOrder(this.detail.orders_id)
            // res.results.data.bpb.map((item, index) => {
            //   this.form.bpb_arr.push({
            //     bpb_id: item.bpb_id,
            //     bpb_detail: item.detail
            //   })
            // })

            // this.form.bpb_arr.map((item, index) => {
            //   item.bpb_detail.map((items, indexs) => {
            //     items.bpb_detail_id = items.bpb_detail_id
            //     items.varian_name = items.varian_name
            //     items.varian_sku = items.varian_sku
            //     items.qty_pcs_diterima = items.qty_pcs_diterima
            //     items.qty_dus_diterima = items.qty_dus_diterima
            //     items.qty_lusin_diterima = items.qty_lusin_diterima
            //     items.qty_pcs_return = items.qty_pcs_return
            //     items.qty_dus_return = items.qty_dus_return
            //     items.qty_lusin_return = items.qty_lusin_return
            //   })
            // })
          }
          this.process.load = false
        })
      },
      async fetchBank () {
        // this.process.load = true
        let params = {
          limit: 10000000000000000000
        }

        await get('admin/bank/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.bank = res.results.data
          }
          // this.process.load = false
        })
      },
      async fetchDetailOrder (id) {
        this.process.load = true
        let params = {
          id: id,
          bpb_id: this.detail.bpb_id ? this.detail.bpb_id : ''
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data_detail = []
            res.results.data.detail.map((item, index) => {
              data_detail.push(
                {
                  ...item,
                  detail_price_dus_new: (Math.round(item.detail_price_per_pcs*item.detail_total_in_dus)*(item.bpb_detail_qty_dus_diterima*1))
                }
              )
            })
            this.order_list = res.results.data
            this.order_list.detail = data_detail
          //   this.total_diskon = 0
          //   this.order_list.map((item, index) => {
          //     item.detail_price_pcs = (item.qty_pcs_diterima*item.varian_pricelist_pcs_ppn) - item.varian_discount*1
          //     item.detail_price_lusin = (item.qty_lusin_diterima*item.varian_pricelist_pcs_ppn*12) - item.varian_discount*1
          //     item.detail_price_dus = (item.qty_dus_diterima*item.varian_pricelist_pcs_ppn*item.varian_total_in_dus) - item.varian_discount*1
          //   })
          //   this.order_list.map((item, index) => {
          //     this.total_nominal += item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1
          //     this.total_diskon += item.varian_discount*1
          //   })
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate(),
        imgValid = true
        if (this.form.payment_bukti_url === '' || this.form.payment_bukti_url === null) {
          this.message.error = 'Bukti Pembayaran harus diisi'
          imgValid = false
        }
        // console.log(isValid, imgValid)
        if (isValid && imgValid) {
          

        this.process.form = true
        let form = {
          invoice_id: this.detail.id,
          payment_method: this.form.payment_method,
          payment_bank_name: this.form.payment_method === 'Tunai' ? '' : this.form.bank.name,
          payment_rek_number: this.form.payment_method === 'Tunai' ? '' : this.form.bank.rek_number,
          payment_bukti_url: this.form.payment_bukti_url
        }

        let url = 'admin/customer_invoice/payment'

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.pembayaran = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          id: this.$route.params.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/customer_invoice/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>

<style>
table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }
</style>